// extracted by mini-css-extract-plugin
export default {"desktopNav":"desktopNav__trrVk","desktopNavNew":"desktopNavNew__OuKIT"};